module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content map"
  }, [(_vm.map.message !== null) ? _c('div', {
    class: 'callout callout-' + _vm.map.message.type
  }, [_c('p', [_vm._v(_vm._s(_vm.map.message.text))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    ref: "elFilters",
    staticClass: "map-filters row realtime"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('toggle-button', {
    attrs: {
      "value": this.$store.state.map.realTimeMode,
      "sync": true,
      "labels": {
        checked: 'Tournées en cours',
        unchecked: 'Tournées terminées'
      },
      "color": {
        checked: '#AADC14',
        unchecked: '#767C97'
      },
      "height": 35,
      "width": 170
    },
    on: {
      "change": _vm.toggleFilterTourneeInProgress
    }
  })], 1)])])]), _vm._v(" "), (_vm.mounted) ? _c('gmap-map', {
    ref: "map",
    style: (_vm.mapStyle),
    attrs: {
      "center": _vm.center,
      "zoom": 13,
      "map-type-id": "roadmap"
    },
    on: {
      "center_changed": function($event) {
        _vm.mapIsDirty = true
      }
    }
  }, _vm._l((_vm.map.realTimeTournees), function(t) {
    return _c('gmap-marker', {
      attrs: {
        "icon": {
          'url': 'static/img/tracker.svg'
        },
        "position": {
          'lat': t.latLastRemontee,
          'lng': t.lonLastRemontee
        }
      },
      on: {
        "click": _vm.showInfoBulle
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "opened": _vm.infoWindowOpened
      },
      on: {
        "closeclick": _vm.closeInfoBulle
      }
    }, [_c('img', {
      staticClass: "top",
      attrs: {
        "src": _vm._f("materielPictoV2")(t.materiel_id),
        "alt": _vm._f("materielTypeV2")(t.materiel_id)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("materielTypeV2")(t.materiel_id)))]), _vm._v("\n          " + _vm._s(_vm._f("materielName")(t.materiel_id)) + "\n          "), _c('br'), _c('span', {
      staticClass: "time grey"
    }, [_vm._v("vu à " + _vm._s(_vm._f("prettyDate")(t.dateLastRemontee)))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "time grey"
    }, [_vm._v(_vm._s(_vm._f("remonteeType")(t.remonteeGPSs[t.remonteeGPSs.length - 1].typeRemonteeGPS)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(!t.demandes) ? _c('div', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.createNewDemande()
        }
      }
    }, [_vm._v(" Nouvelle demande ")])]) : _vm._e()])])], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.updateModal === true) ? _c('demande-modal', {
    attrs: {
      "title": "Modifier une demande"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('demande-form', {
    attrs: {
      "slot": "body",
      "update-demande": _vm.demande
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createModal === true) ? _c('demande-modal', {
    attrs: {
      "title": "Créer une nouvelle demande"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('demande-form', {
    attrs: {
      "slot": "body"
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e30effec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Realtime.vue
// module id = 2133
// module chunks = 2